import * as PIXI from "pixi.js";
import { Spine } from "@pixi/spine-pixi";
import { soundManager } from "./shared/UI/SoundManager";

export class Multiplier extends PIXI.Container {
    private skeleton: Spine;
    private counter: number = 0;
    private multiplier: number = 0;
    private maxCounter: number = 0;
    private scatterSteps: Spine[] = [];

    constructor(multiplier: number, maxCounter: number = 0) {
        super();
        this.skeleton = Spine.from({
            skeleton: "wildJson",
            atlas: "wildAtlas",
        });
        this.multiplier = multiplier;
        this.skeleton.scale.set(0.1);
        this.addChild(this.skeleton);

        const distance = 35;
        for (let i = 0; i < maxCounter; i++) {
            const skeleton = Spine.from({
                skeleton: "scatterStepJson",
                atlas: "scatterStepAtlas",
            });
            skeleton.scale.set(0.25);
            skeleton.x = distance * i - ((maxCounter - 1) * distance) / 2;
            skeleton.y = 40;
            skeleton.state.setAnimation(0, "idle_off", true);
            this.scatterSteps.push(skeleton);
            this.addChild(skeleton);
        }
        this.counter = 0;
        this.maxCounter = maxCounter;

        if (multiplier === 1) {
            this.skeleton.skeleton.setSkinByName(`w`);
        } else {
            this.skeleton.skeleton.setSkinByName(`x${multiplier}`);
        }
        this.skeleton.state.setAnimation(0, "m_idle_off", true);
        this.skeleton.state.addListener({
            event: function(entry, event) { },
            complete: (entry) => { },
            start: () => { },
            end: function(entry) { },
            dispose: function(entry) { },
        });
    }

    isFull() {
        return this.counter === this.maxCounter;
    }

    collect() {
        this.counter++;
        if (this.counter >= this.maxCounter) {
            this.counter = this.maxCounter;
            this.turnOn();
            soundManager.playSound("upgradeTheMultiplier");
        }
        this.scatterSteps.forEach((step, index) => {
            if (index < this.counter) {
                step.state.setAnimation(0, "idle_on", true);
            } else {
                step.state.setAnimation(0, "idle_off", true);
            }
        });
    }

    turnOn() {
        if (this.skeleton.state.getCurrent(0)?.animation?.name === "m_idle_on") {
            return;
        }
        this.skeleton.state.setAnimation(0, "m_turn_on", false).timeScale;
        this.skeleton.state.addAnimation(0, "m_idle_on", true).timeScale =
            Math.random() * 0.5 + 0.75;
    }

    turnOff() {
        this.scatterSteps.forEach((step) => {
            step.state.setAnimation(0, "idle_off", true);
        });
        this.counter = 0;
        if (this.skeleton.state.getCurrent(0)?.animation?.name === "m_idle_off") {
            return;
        }
        this.skeleton.state.setAnimation(0, "m_turn_off", false);
        this.skeleton.state.addAnimation(0, "m_idle_off", true);
    }

    getFireGlobalPosition(): PIXI.Point {
        return new PIXI.Point(
            this.skeleton.getGlobalPosition().x,
            this.skeleton.getGlobalPosition().y,
        );
    }

    getMultiplier() {
        return this.multiplier;
    }

    hideCollector() {
        this.scatterSteps.forEach((value) => {
            value.visible = false;
        });
    }

    showCollector() {
        this.scatterSteps.forEach((value) => {
            value.visible = true;
        });
    }
}
